import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { decodeJWT } from '../utils/jwt';

const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('auth_token');
  const location = useLocation();

  if (!token) {
    const returnPath = location.pathname + location.search;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(returnPath)}`}
        replace
        state={{ from: location }}
      />
    );
  }
  if (requiredRole && String(decodeJWT(token)?.role || '').toUpperCase() !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
